import React from "react";
import Icon from "components/AppIcon";

const SAVED_SEARCHES = [
  { id: 1, label: "UK Renewable Energy >12% IRR" },
  { id: 2, label: "European Transport, Low Risk" },
  { id: 3, label: "Digital Infrastructure, Diligence Stage" },
];

export default function SavedSearchesBar({ onApply }) {
  return (
    <div className="flex items-center gap-3 overflow-x-auto pb-1">
      <span className="text-xs font-caption text-muted-foreground whitespace-nowrap flex items-center gap-1 flex-shrink-0">
        <Icon name="Bookmark" size={13} />
        Saved:
      </span>
      {SAVED_SEARCHES?.map((s) => (
        <button
          key={s?.id}
          onClick={() => onApply(s)}
          className="flex-shrink-0 px-3 py-1.5 rounded-full border border-border bg-background text-xs font-caption text-foreground hover:border-primary hover:text-primary transition-all duration-200 whitespace-nowrap"
        >
          {s?.label}
        </button>
      ))}
    </div>
  );
}